import {createContext} from "react";
import {useModals} from "./useModals";

export const ModalContext = createContext();

const ModalProvider = ({children}) => {
    const modals = useModals();

    return (
        <ModalContext.Provider value={modals}>
            {children}
        </ModalContext.Provider>
    )
}

export default ModalProvider;